import { Navigate } from 'react-router';

import { ANY_SPORT_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const ComposeTeam = () => {
  const { generateSportContextPath } = useSportContext();
  return <Navigate to={generateSportContextPath(ANY_SPORT_PLAY)} />;
};

export default ComposeTeam;
